
import api from '../interceptors/interceptor';
import { API_ROUTES } from '../constants/apiRoutes';

export class ConfigRepository {
  private static instance: ConfigRepository;

  /**
   * Singleton pattern - ensure only one instance exists
   */
  public static getInstance(): ConfigRepository {
    if (!ConfigRepository.instance) {
      ConfigRepository.instance = new ConfigRepository();
    }
    return ConfigRepository.instance;
  }

  /**
   * Get all models
   */
  public async getConfig(): Promise<any> {
    return (await api.get(API_ROUTES.CONFIG))?.data;
  }

}
